<template>
  <div class="page">
    <div class="version">v{{ version }}</div>
    <div class="main" id="area">
      <Area v-show="!$store.state.loadingText" />
    </div>
    <Info />
    <ForceSDIndicator />
    <Loading v-show="$store.state.loadingText" />

    <div class="action" >
      <div v-if="debug" class="action-item" :style="{ color: '#57fffe' }">
        缓存大小： 倍速：
      </div>
    </div>
    <Bottom />
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import Area from '@/components/Map/index.vue';
import Loading from './component/Loading/index';
import { ElMessage } from 'element-plus';
import { PerspectiveEnum } from '@/store/types';
import { store } from '@/store';
import { getQueryVariable } from '@/utils/utils';
import copy from 'copy-to-clipboard';
import Bottom from './component/Bottom/index.vue';
import Info from './component/Info/index.vue';
import ForceSDIndicator from './component/ForceSDIndicator/index.vue';
import { getVehicleInfo } from '@/service';
import config from '../../../package.json'

export default defineComponent({
  name: 'Home',
  components: {
    Area,
    Loading,
    Bottom,
    Info,
    ForceSDIndicator,
  },
  data() {
    return {
      getVehicleInfo,
      PerspectiveEnum,
      debug: null,
      version:config.version
    };
  },
  methods: {
    onCopyClick(value) {
      if (copy(value)) {
        ElMessage.success('复制成功');
      }
    },
    getData() {
      localStorage.removeItem('channelInfo');
      let vehicleId = getQueryVariable('vehicleId');
      this.debug = getQueryVariable('debug');

      store.commit('wsModule/setVehicleId', vehicleId);

      this.getVehicleInfo(vehicleId).then((e) => {
        let param = {
          width: 1.564,
          backEdgeToCenter: 0.816,
          height: 2.1025,
          length: 3.6335,
        };
        if (e.success) {
          param.backEdgeToCenter =
            e.data?.vehicleModelDto?.backEdgeToCenter / 1000 || 0.816;
          param.width = e.data?.vehicleModelDto?.width / 1000 || 1.564;
          param.height = e.data?.vehicleModelDto?.height / 1000 || 2.1025;
          param.length = e.data?.vehicleModelDto?.length / 1000 || 3.6335;
        }
        store.commit('wsModule/setVehicleInfo', { vehicleParam: param });
      });

      store.commit('changePerspective', {
        type: PerspectiveEnum.overlook,
        t: +new Date(),
      });     
    },
  },
  mounted() {
    this.getData();
  },
  watch: {
    $route: {
      handler() {
        this.getData();
      },
    },
  },
  unmounted() {
    localStorage.removeItem('channelInfo');
    this.$store.dispatch('wsModule/WS_CLOSE');
    this.$store.dispatch('wsModule/destroy');
  },
});
</script>
<style lang="less">
.setting {
  position: fixed;
  top: 100px;
  left: 0;
  z-index: 9999;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(255, 255, 255, 0.2);
  font-size: 30px;
  color: #fff;
  border-radius: 2px;
  box-sizing: border-box;
  padding: 4px;

  .setting-item {
    line-height: 1;
    padding: 4px;
  }

  .setting-item:hover {
    color: var(--theme);
    cursor: pointer;
  }

  .setting-item:active {
    opacity: 0.5;
  }
}

.setting-box {
  position: fixed;
  top: 40%;
  left: 40%;
  z-index: 9999;
  background: rgba(255, 255, 255, 0.3);
  color: #fff;
  box-sizing: border-box;
  padding: 4px 12px;
  border-radius: 4px;

  .setting-box-item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 12px 0;

    > div {
      width: 60px;
      text-align: end;
      margin-right: 8px;
    }

    > input {
      outline: none;
      border: none;
      height: 24px;
      padding: 2px 4px;
      border-radius: 4px;
    }

    > input:focus {
      outline: 1px solid var(--theme);
      border: 1px solid var(--theme);
    }
  }

  .btn-box {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .btn {
      border: 1px solid var(--theme);
      text-align: center;
      padding: 4px;
      border-radius: 4px;
      color: var(--theme);
      cursor: pointer;
      margin-top: 8px;
    }

    .btn:active {
      opacity: 0.5;
    }
  }
}

.setting-box-show {
  display: block;
}

.setting-box-hide {
  display: none;
}

.action {
  position: fixed;
  top: 8px;
  right: 8px;
  z-index: 3002;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(255, 255, 255, 0.2);
  font-size: 30px;
  color: #fff;
  border-radius: 2px;
  box-sizing: border-box;
  padding: 4px;

  .action-item {
    line-height: 1;
    padding: 4px;
  }

  .curr-time {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #57fffe;
  }

  .action-item:hover {
    color: var(--theme);
    cursor: pointer;
  }

  .action-item:active {
    opacity: 0.5;
  }

  .action-item-middle {
    border-left: 1px solid #fff;
    border-right: 1px solid #fff;
  }

  .action_active {
    color: var(--theme);
  }
}

.lamp {
  width: 200px;
  position: fixed;
  right: 8px;
  bottom: 172px;
  z-index: 99;
}

.wheel {
  width: 200px;
  position: fixed;
  right: 8px;
  bottom: 8px;
  z-index: 99;
}

:root {
  --theme: #57fffe;
  --bg: rgba(255, 255, 255, 0.4);
  // user-select: none;
}

.ps__rail-y {
  width: 0.71667vw !important;
  background: none !important;
}

.ps__thumb-y {
  background-color: var(--theme) !important;
  width: 0.41667vw !important;
}

.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

.card {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 5px;
  color: #fff;
  padding: 5px;
}

.border-right {
  position: relative;

  &::after {
    position: absolute;
    content: '';
    height: 90%;
    width: 1px;
    background: #fff;
    opacity: 0.5;
    top: 5%;
    right: 0;
  }
}

.flex {
  display: flex;
}

.flex1 {
  flex: 1;
  height: 100%;
}

.active {
  color: var(--theme);
}
</style>
<style lang="less" scoped>
.page {
  position: relative;
  height: 100vh;
  overflow: hidden;
  .version {
    position: absolute;
    left: 4px;
    z-index: 1000;
    font-size: 15px;
    font-weight: bolder;
    color: #A6D8E9;
    // -webkit-text-stroke: 1px #A6D8E9;
    // -webkit-text-fill-color: transparent;
  }
}

.main {
  width: 100%;
  flex: 1;
  position: relative;
  background: #021a2c;

  video {
    object-fit: cover;
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    height: 100%;
  }
}
</style>
